(ns manage.content-variant-page.macro.view
  (:require [clojure.edn :refer [read-string]]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.ui.list :as ui.list]
            [common.ui.store :as store]
            [manage.content-configuration-page.predicate.view :refer [add-item-cfg label]]
            [manage.content-variant-page.macro.db :refer [->MacroGroup some-macro-eid]]
            [re-frame.core :as rf]
            [uix.core :refer [$]]))

(defn entity-cfg [mg]
  (let [m (some-macro-eid mg)]
    {:entity/ref mg
     :entity/label [label (store/->DataScriptDBEntity m)]
     :entity/icon [:macro/icon m]}))

(defn list-cfg [p]
  {:entity/label "Triggers"
   :list/items [:placeholder/unique-macros p]
   :list/->item-db-entity (partial apply ->MacroGroup)
   :list/->item-cfg entity-cfg
   :list/add-item-cfg
   (assoc (add-item-cfg nil)
          :add-item/add-fn (fn [macro-str]
                             (rf/dispatch [:placeholder/add-macro p (read-string macro-str)])))
   :list/delete-item-event :macro/delete-group
   :list/empty-msg ($ ui.list/empty-msg {:title "Add trigger"}
                      ($ :p
                         "To use dynamic data in your targeting, a macro should be
                          added to act as a trigger for a rule."))})

(defmodal confirm-delete :macro/confirm-delete
  [{:keys [macro-group]}]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:macro/delete-group-mapped macro-group])
    :entity-name "macro"
    :title "This macro is still in use"
    :submit-button-label "Update mapping and delete macro"}
   [:p "This macro is used as trigger in the targeting value mappings. If you
        choose to continue anyway, the mappings will also be deleted."]])
